function initToggleFilters() {
  document.addEventListener("DOMContentLoaded", () => {
    const toggleButtons = document.querySelectorAll(
      ".js-toggle-product-filters",
    );
    const sidebars = document.querySelectorAll(".js-product-filter-sidebar");

    // Create overlay
    const overlay = document.createElement("div");
    overlay.className = "js-product-filter-overlay";
    document.body.appendChild(overlay);

    function toggleSidebar() {
      sidebars.forEach((sidebar) => {
        sidebar.classList.toggle("c-product-filter-sidebar--open");
      });
      overlay.classList.toggle("active");
    }

    toggleButtons.forEach((btn) => {
      btn.addEventListener("click", toggleSidebar);
    });

    // Close sidebar if overlay is clicked
    overlay.addEventListener("click", toggleSidebar);
  });
}

initToggleFilters();

export { initToggleFilters };
